import { type SVGProps } from 'react';

/**
 * Default placeholder motif for EmptyState — a sun + mountain "image" glyph,
 * extracted from Figma (node 6305:113). Uses `currentColor` so the surrounding
 * container controls its tone (EmptyState sets the muted secondary icon color).
 *
 * The original Figma motif is drawn at 0.5 opacity in grayscale-600 (#676979).
 */
export const MotifPlaceholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48.5"
    height="30.5"
    viewBox="0 0 48.5 30.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <circle opacity="0.5" cx="41.25" cy="7" r="7" fill="currentColor" />
    <path
      opacity="0.5"
      d="M24.25 8L48.4977 30.5H0L24.25 8Z"
      fill="currentColor"
    />
  </svg>
);

MotifPlaceholder.displayName = 'MotifPlaceholder';
